import React, {useState, useEffect, useCallback} from 'react';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useStoreActions, useStoreState } from "easy-peasy";

import CartDomain from './CartDomain';


export default function BuyDomains() {
  const linkoln_domains = useStoreState(state => state.linkoln_domains.domains);
  const cart = useStoreState(state => state.cart.subdomains);

  const [cart_total, setCartTotal] = useState(0);
  const [custom_domain_credits, setCustomDomainCredits] = useState(0);
  const [domain, setDomain] = useState("");
  const [subdomain, setSubDomain] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState({});

  const getLinkolnDomains = useStoreActions(actions => actions.linkoln_domains.getDomains);
  const reserveDomain = useStoreActions(actions => actions.linkoln_domains.reserveDomain);
  const releaseDomain = useStoreActions(actions => actions.linkoln_domains.releaseDomain);
  const getCart = useStoreActions(actions => actions.cart.getCart);
  const checkout = useStoreActions(actions => actions.cart.checkout);
  const checkCoupon = useStoreActions(actions => actions.cart.checkCoupon);


  const checkOut = () => {
      checkout({linkoln_subdomains: cart, custom_domains: custom_domain_credits}).then((result) => {
        console.log(result);
        if (result.status === "redirect") {
          window.location.replace(result.url);
        } else if (result.status === "refresh") {
          alert("Some of the domains you chose may have expired, please select them again.");
          window.location.reload();
        } else if (result.status === "error") {
            alert("There was an error processing the order.");
        }
      })
  };

  const checkCouponCode = () => {
      checkCoupon(couponCode).then((coupon) => {
        if (!coupon.is_valid) {
          alert("Invalid or expired coupon code.");
          return;
        }
        if (coupon.product === "linkoln_subdomain" && cart.length === 0) {
          alert("You must add a Linkoln subdomain to your cart to apply this coupon.");
          return;
        }
        if (coupon.product === "custom_domain" && cart.length === 0) {
          alert("You must add a custom domain credit to your cart to apply this coupon.");
          return;
        }
        setAppliedCoupon(coupon);
      });
  };

  const clearForm = useCallback(() => {
    setSubDomain("");
    setDomain(linkoln_domains[0]);
  }, [linkoln_domains]);

  const removeDomain = (full_domain) => {
    let parts = full_domain.split(".");
    let this_subdomain = parts.shift();
    let this_domain = parts.join('.');

    releaseDomain({domain: this_domain, subdomain: this_subdomain}).then((result) => {
      getCart();
    });
  };

  const removeCustomDomainCredits = () => {
    calcCartTotal();
    setCustomDomainCredits(0);
  };

  const addCustomDomainCredit = () => {
    calcCartTotal();
    setCustomDomainCredits(custom_domain_credits + 1);
  };

  const calcCartTotal = useCallback(() => {
    let discount = 0;
    if (appliedCoupon) {
      if (appliedCoupon.product === "linkoln_subdomain" && cart.length > 0) {
        discount += 9;
      } else if (appliedCoupon.product === "custom_subdomain" && custom_domain_credits > 0) {
        discount += 7;
      }
    }
    setCartTotal(cart.length * 7 + custom_domain_credits * 9 - discount);
  }, [cart, custom_domain_credits, appliedCoupon]);

  const addSubdomain = (e) => {
    if (!domain) {
      alert("You must select a domain");
      return;
    }
    reserveDomain({domain: domain, subdomain: subdomain}).then((result) => {
      if (result === "taken") {
        alert(domain + "." + subdomain + " is already taken");
      } else {
        getLinkolnDomains();
      }
      clearForm()
      setTimeout(getCart, 500);
    });
  };

  useEffect(() => {
    getLinkolnDomains()
    getCart()
  }, [getLinkolnDomains, getCart]);

  useEffect(() => {
    clearForm();
  }, [linkoln_domains, clearForm]);

  useEffect(() => {
    calcCartTotal();
  }, [linkoln_domains, custom_domain_credits, calcCartTotal]);

  return (
    <>
    <div className="container-md px-0">
      <Row>
        <Col>
          <h1>Choose Your Domains</h1>
          <p>You need a domain to create links.  The domain(s) you choose will be used for your links.</p>
        </Col>
      </Row>
    </div>
    <div className="container-md px-0">
      <div className="row">
        <div className="col-12">
            <Form onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="col-md mb-4">
                <div className="shadow rounded p-3 h-100 text-center">
                    <h3 className="bg-secondary text-white p-2 text-center text-capitalize">Add a domain you already own</h3>
                    <p className="fs-4 fw-bold text-capitalize">$9 one-time fee</p>
                    <p>This process involves setting up DNS records for your domain.  If you are not comfortable doing so, this option might not be for you.</p>
                    <Button variant="danger my-3" onClick={addCustomDomainCredit}>Add credit for custom domain</Button>
                </div>
              </div>
              <div className="col-md mb-4">
                <div className="shadow rounded p-3 h-100 text-center">
                <h3 className="bg-secondary text-white p-2 text-center text-capitalize">Add a Linkoln subdomain</h3>
                <p className="fs-4 fw-bold text-capitalize">$7 one-time fee</p>
                  <div className="row d-flex align-items-end">
                    <div className="col-sm text-start">
                    <Form.Label>Subdomain:</Form.Label>
                        <Form.Control as="input" onChange={(e) => setSubDomain(e.target.value)} value={subdomain}/>
                    </div>
                    <div className="col-sm text-start">
                        <Form.Label>Domain:</Form.Label>
                        <Form.Select onChange={(e) => setDomain(e.target.value)} value={domain}>
                        { linkoln_domains &&
                            linkoln_domains.map(domain => (
                                <option value={domain} key={domain}>{domain}</option>
                            ))
                        }
                        </Form.Select>
                    </div>
                    <div className="col-sm">
                      <Button variant="danger mt-4 mt-sm-0" onClick={addSubdomain}>Add subdomain</Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>


      <div className="row">
        <div className="col-12">
            <h3>Cart - Total: ${cart_total}</h3>
          <Table striped bordered responsive className="bg-white">
            <thead className="thead-dark">
                <tr><th>Subdomains</th></tr>
            </thead>
            <tbody>
            {(custom_domain_credits || null) && (
                <tr key="custom_domain_credits">
                  <td>Custom Domain Credits: {custom_domain_credits}</td>
                  <td><Button variant="danger" onClick={removeCustomDomainCredits}>Remove</Button></td>
                </tr>
            )}
            {cart &&
              cart.map(domain => (
                  <CartDomain key={domain} domain={domain} removeDomain={removeDomain}/>
              ))
            }
            </tbody>
          </Table>
          <div className="row">
            <div className="col-12">
              <div className="col-sm text-start">
                <Form.Label>Coupon:</Form.Label>
                <Form.Control as="input" onChange={(e) => setCouponCode(e.target.value)} value={couponCode}/>
              </div>
              <div className="col-sm text-start">
                <Button variant="danger" onClick={checkCouponCode}>Apply Coupon</Button>
              </div>
              <div className="col-sm text-start">
                <Button variant="danger" onClick={checkOut}>Checkout</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
